import React from 'react'
// import SliderSimple from './SliderSimple';

import MenuPrincipal from './MenuPrincipal'
import MenuMobile from './MenuMobile'
import BoutonsLateraux from './BoutonsLateraux'
import Entete from './Entete'
import Actualite from './Actualite'
import Professeurs from './Professeurs'
import HorairesTarifs from './HorairesTarifs'
import Evenements from './Evenements'
import Contacts from './Contacts'
import Parallax from './Parallax'
import '../../../styles/App.css'
// import FormulaireAdmin from './../../Pages/FormAdmin/FormAdmin';

// function PrincipalePage () {
const PagePrincipale = () => {
  return (
    <div className="App">
      <MenuPrincipal />
      <MenuMobile />
      <BoutonsLateraux />
      <Entete />
      <Actualite />
      <Parallax
        speed={0.2}
        // image="/images/IMG_4779_web.jpg"
        image="/images/imageProfesseurs.jpg"
        message="Professeurs"
      />
      <Professeurs />
      <Parallax
        speed={0.2}
        // image="./images/DemosForum2016_11_web.jpg"
        image="./images/imagePlanningTarifs.jpg"
        message="Planning et Tarifs"
      />
      <HorairesTarifs />
      <Parallax
        speed={0.2}
        // image="./images/DSLQ2016_web.jpg"
        image="./images/imageEvenements.jpg"
        message="Evènements"
      />
      <Evenements />
      <Parallax
        speed={0.2}
        // image="./images/DSLQ2017_05_web.jpg"
        image="./images/imageContacts.jpg"
        message="Contacts"
      />
      <Contacts />
      {/* <FormAdmin /> */}
    </div>
  )
}

export default PagePrincipale
